import { render } from "./UserService.vue?vue&type=template&id=2d6459aa&scoped=true&ts=true"
import script from "./UserService.vue?vue&type=script&lang=ts"
export * from "./UserService.vue?vue&type=script&lang=ts"

import "./UserService.vue?vue&type=style&index=0&id=2d6459aa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6459aa"]])

export default __exports__